import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/auth';

const config = {
  apiKey: "AIzaSyDX0xmM89hlSRsZp2KwrJDm3Ik9LvNaAxQ",
  authDomain: "cklmprono-prd.firebaseapp.com",
  databaseURL: "https://cklmprono-prd.firebaseio.com",
  projectId: "cklmprono-prd",
  storageBucket: "cklmprono-prd.appspot.com",
  messagingSenderId: "151357437261",
  appId: "1:151357437261:web:87250a73781fdc4a",
}
firebase.initializeApp(config);

const resolveUser = function(fbUser) {
  if(fbUser) {
    return fbUser.getIdTokenResult(true).then((token) => {
      console.log("User subscription: " + JSON.stringify(token.claims.subscription) + " admin=" + (token.claims.admin ? "true":"false"))
      const subscription = token.claims.subscription || { active: false, expires_at: 0 }
      const expirationTime = (subscription.expires_at || 0) * 1000;
      auth.user = { uid: fbUser.uid, email: fbUser.email, name: fbUser.displayName, photoURL: fbUser.photoURL, admin: token.claims.admin, subscribed: token.claims.admin || (expirationTime > new Date().getTime()), subscription: subscription }
      return auth.user;
    })
  } else {
    auth.user = null
    return auth.user;
  }
}
export const init = new Promise(function(resolve) {
  firebase.auth().onAuthStateChanged((user) => resolve(resolveUser(user)))
})

export default firebase;
export const db = firebase.firestore()
export const auth = {
  fb: firebase.auth(),
  user: null,
  createUserWithEmailAndPassword: (email, password, name) => firebase.auth().createUserWithEmailAndPassword(email, password).then((result) => result.user.updateProfile({ displayName: name, photoURL: "https://cklmprono-prd.web.app/img/profile.png" }).then(() => resolveUser(result.user))),
  signInWithEmailAndPassword: (email, password) => firebase.auth().signInWithEmailAndPassword(email, password).then((result) => { return resolveUser(result.user); }),
  signInWithPopup: (provider) => firebase.auth().signInWithPopup(provider).then((result) => { return resolveUser(result.user); })
}